import Image from "grandus-lib/components-atomic/image/Image";

import styles from "components/additionalInfo/Info.module.scss";

const Info = ({
    title,
    text,
    photo
}) => {
  return (
    <div className={styles.info}>
        <div className={styles.title}>
            { photo ? (
                <Image
                    photo={photo}
                    size={"25x25"}
                    type={"jpg"}
                />
            ) : ("")}
            <h4 className={styles.name}>
                {title}
            </h4>
        </div>
        <div className={styles.text}>
            <div
                dangerouslySetInnerHTML={{
                __html: text,
                }}
            />
        </div>
    </div>
  );
};

export default Info;
